import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Box, Button, IconButton, Tooltip } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { CreateListingProduct } from 'src/types';

interface Props {
  onClearAll: () => void;
  onRemove: (index: number) => void;
  listingErrorList?: CreateListingProduct[];
}

const Component = ({
  listingErrorList = [],
  onRemove,
  onClearAll
}: Props) => {
  return (
    <Box style={{ marginTop: 10 }}>
      {listingErrorList.length > 0
        ? listingErrorList?.map((errorSN, index) => (
            <Alert
              style={{ marginBottom: 1 }}
              key={`${errorSN?.serial_no}${index}`}
              severity="error"
              action={
                  <Tooltip title="Remove" placement="top">
                    <IconButton
                      aria-label="close"
                      color="inherit"
                      size="medium"
                      onClick={() => {
                        onRemove(index);
                      }}
                    >
                      <DeleteOutlineIcon fontSize="inherit" />
                    </IconButton>
                  </Tooltip>
              }
            >
              <AlertTitle>{errorSN?.serial_no}</AlertTitle>
              {errorSN?.temporary_error_string}
            </Alert>
          ))
        : null}
      {listingErrorList.length > 0 ? (
        <Box display="flex" justifyContent="flex-end">
          <Button onClick={onClearAll} color="secondary">
            Clear All Invalid Serial No(s)
          </Button>
        </Box>
      ) : null}
    </Box>
  );
};

export const ListingAddListError = React.memo(Component);
